/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api: {

    // --- URLs de producción (nube) ---
    /*dataApis: 'https://apirest.laboralsoft.com.mx/public/api',
    utcvApis: 'https://apirest.laboralsoft.com.mx/public/api',
    dataDownloads: 'https://apirest.laboralsoft.com.mx',
    CatalogsApis: 'https://apirest.laboralsoft.com.mx/public/api/catalogs',
    adminApis: 'https://apirest.laboralsoft.com.mx/public/api/manage/',
    templateApis: 'https://apirest.laboralsoft.com.mx/public/api/template/',
    standardApis: 'https://apirest.laboralsoft.com.mx/public/api/'*/

    // --- URLs relativas: el dev-server las reenvia a la API (proxy.conf.js, API_PROXY_TARGET),
    // asi el front funciona desde cualquier host (localhost, IP del servidor o dominio) sin CORS.
    dataApis: '/api',
    utcvApis: '/api',
    dataDownloads: '',
    CatalogsApis: '/api/catalogs',
    adminApis: '/api/manage/',
    templateApis: '/api/template/',
    standardApis: '/api/'

  },
};
